var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUploadFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6508 2.24074C12.2763 1.91975 11.7237 1.91975 11.3492 2.24074L7.84923 5.24074C7.4299 5.60017 7.38134 6.23147 7.74076 6.65079C8.10018 7.07012 8.73148 7.11868 9.15081 6.75926L11 5.17422V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V5.17422L14.8492 6.75926C15.2686 7.11868 15.8999 7.07012 16.2593 6.65079C16.6187 6.23147 16.5701 5.60017 16.1508 5.24074L12.6508 2.24074ZM4 16C4 15.4477 3.55228 15 3 15C2.44772 15 2 15.4477 2 16V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V16C22 15.4477 21.5523 15 21 15C20.4477 15 20 15.4477 20 16V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V16Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUploadFiles);
export default __webpack_public_path__ + "static/media/ic_upload-files.969efd42d6a903a13c639b934f4d8eb2.svg";
export { ForwardRef as ReactComponent };